import { IncentivePlan } from '../../../../../apis/types'
import { formatDateTime } from '../../../../../util/string'

export const normalizeActorName = (actor: any): string | null => {
    if (!actor) return null
    if (actor === -1) return 'System'

    if (typeof actor === 'string') {
        const normalizedActor = actor.trim()
        if (normalizedActor === '-1' || normalizedActor.toLowerCase() === 'system') return 'System'
        if (/^c[a-z0-9]{24,26}$/.test(normalizedActor)) return 'Unknown'
        return normalizedActor
    }

    if (actor?.id === -1 || actor?.userId === -1) return 'System'

    if (typeof actor.email === 'string') {
        const normalizedEmail = actor.email.trim()
        if (normalizedEmail === '-1' || normalizedEmail.toLowerCase() === 'system') return 'System'
        if (/^c[a-z0-9]{24,26}$/.test(normalizedEmail)) return 'Unknown'
    }

    const fullName = [actor.firstName, actor.lastName].filter(Boolean).join(' ')
    return fullName || actor.email || null
}

export const formatDateByText = (dateValue: string | Date | null | undefined, actor: any): string | null => {
    const parts: string[] = []
    if (dateValue) parts.push(formatDateTime(new Date(dateValue)))
    const actorName = normalizeActorName(actor)
    if (actorName) parts.push(`by ${actorName}`)
    return parts.length > 0 ? parts.join(' ') : null
}

export const getCreatedDetails = (
    createdAt: string | Date | null | undefined,
    createdBy: any,
    reason?: string | null
): { dateByText: string | null; reason: string | null } => {
    return {
        dateByText: formatDateByText(createdAt, createdBy),
        reason: reason?.trim() || null,
    }
}

export const getCancelledCompletedDetails = (
    plan: IncentivePlan
): { dateByText: string | null; reason: string | null } | null => {
    const hasClosedStatus = plan.status === 'CANCELLED' || plan.status === 'COMPLETED'
    if (!hasClosedStatus) return null

    const isCredit = plan.type === 'ACCOMMODATION_CREDIT'
    const actor = isCredit ? (plan as any).reversedBy : (plan as any).cancelledBy
    const dateValue = isCredit ? (plan as any).reversedAt : (plan as any).cancelledAt
    const reason = isCredit
        ? (plan as any).reverseReason ?? (plan as any).reversalReason
        : (plan as any).cancelReason ?? (plan as any).cancellationReason

    return {
        dateByText: formatDateByText(dateValue, actor),
        reason: reason?.trim() || null,
    }
}
